import React, { useEffect } from 'react'

import { RibbonTriggerContainer } from 'RibbonTrigger'
import classnames from 'classnames'
import { LayoutPageWrapper, VerticalStages, VerticalStagesItem } from 'goustouicomponents'
import PropTypes from 'prop-types'

import Overlay from 'components/Overlay'
import { AgeVerificationPopUp } from 'components/Product/AgeVerification'
import {
  ADD_CHICKEN_BREAST_PAINTED_DOOR_SEEN_COOKIE_NAME,
  DOUBLE_PROTEIN_PAINTED_DOOR_SEEN_COOKIE_NAME,
  PAINTED_DOOR_SURVEY_SEEN_COOKIE_NAME,
} from 'routes/Menu/hooks/useIsAddAProteinPaintedDoorEnabled'
import { PageLoader } from 'routes/OrderConfirmation/components/PageLoader'
import Cookies from 'utils/GoustoCookies'

import { AddProteinPaintedDoorSurveyTracking } from './components/AddProteinPaintedDoorSurveyTracking'
import { AwinPixel } from './components/AwinPixel'
import { Market } from './components/Market'
import { OrderConfirmationHeader } from './components/OrderConfirmationHeader'
import { ReferAFriend } from './components/ReferAFriend'

import css from './OrderConfirmation.css'

const propTypes = {
  ageVerified: PropTypes.bool.isRequired,
  headerDetails: PropTypes.oneOfType([
    PropTypes.shape({
      deliveryDate: PropTypes.string,
      deliveryStart: PropTypes.string,
      deliveryEnd: PropTypes.string,
      whenCutoffTime: PropTypes.string,
      whenCutoffDate: PropTypes.string,
    }),
    PropTypes.bool,
  ]),
  showHeader: PropTypes.bool.isRequired,
  userFetchReferralOffer: PropTypes.func.isRequired,
  userVerifyAge: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

const defaultProps = {
  headerDetails: {},
}

export const OrderConfirmation = ({
  userFetchReferralOffer,
  userVerifyAge,
  ageVerified,
  headerDetails,
  isLoading,
  showHeader,
}) => {
  const [hasConfirmedAge, setHasConfirmedAge] = React.useState(false)
  const [showAgeVerification, setShowAgeVerification] = React.useState(false)
  const [shouldShowAddProteinSurvey, setShouldShowAddProteinSurvey] = React.useState(false)

  useEffect(() => {
    userFetchReferralOffer()
  }, [userFetchReferralOffer])

  const toggleAgeVerificationPopUp = () => {
    setShowAgeVerification(!showAgeVerification)
  }

  const onAgeConfirmation = (isOver18) => {
    setHasConfirmedAge(true)
    userVerifyAge(isOver18, true)
  }

  React.useEffect(() => {
    const paintedDoorCookieSet = !!(
      Cookies.get(DOUBLE_PROTEIN_PAINTED_DOOR_SEEN_COOKIE_NAME) ||
      Cookies.get(ADD_CHICKEN_BREAST_PAINTED_DOOR_SEEN_COOKIE_NAME)
    )
    const paintedDoorSurveySeen = !!Cookies.get(PAINTED_DOOR_SURVEY_SEEN_COOKIE_NAME)
    if (!paintedDoorSurveySeen && paintedDoorCookieSet) {
      window.setTimeout(() => {
        setShouldShowAddProteinSurvey(true)
        Cookies.set(PAINTED_DOOR_SURVEY_SEEN_COOKIE_NAME, '1')
      }, 2000)
    }
  }, [])

  const isUnderAge = hasConfirmedAge && !ageVerified

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <LayoutPageWrapper padding="large-screens-only">
      <div className={css.pageContent} data-testing="orderConfirmationContainer">
        <Overlay open={showAgeVerification} from="top">
          <AgeVerificationPopUp
            onClose={toggleAgeVerificationPopUp}
            isUnderAge={isUnderAge}
            onAgeConfirmation={onAgeConfirmation}
          />
        </Overlay>

        {showHeader ? (
          <VerticalStages hasFullWidth>
            <VerticalStagesItem title="Order created" isCompleted backgroundColor="lightGrey">
              <div>
                <OrderConfirmationHeader
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...headerDetails}
                />
                <div className={classnames(css.mobileShow, css.rafMobile)}>
                  <ReferAFriend />
                </div>
              </div>
            </VerticalStagesItem>

            <VerticalStagesItem
              title="Add desserts, drinks, snacks & more from the Gousto Market"
              isCompleted={false}
            >
              <Market
                ageVerified={ageVerified}
                toggleAgeVerificationPopUp={toggleAgeVerificationPopUp}
              />
            </VerticalStagesItem>
          </VerticalStages>
        ) : (
          <div>
            <h3 className={css.marketPlaceTitle}>Gousto Market</h3>
            <Market
              ageVerified={ageVerified}
              toggleAgeVerificationPopUp={toggleAgeVerificationPopUp}
            />
            <div className={classnames(css.mobileShow, css.rafMobile)}>
              <ReferAFriend />
            </div>
          </div>
        )}

        <AwinPixel />
      </div>
      <RibbonTriggerContainer name="order-confirmation-web" />
      {shouldShowAddProteinSurvey && (
        <div style={{ display: 'none' }} data-testid="add-a-protein-survey">
          <AddProteinPaintedDoorSurveyTracking />
          <RibbonTriggerContainer name="add-a-protein" />
        </div>
      )}
    </LayoutPageWrapper>
  )
}

OrderConfirmation.propTypes = propTypes
OrderConfirmation.defaultProps = defaultProps
